import { BehaviorSubject } from 'rxjs';
import { _throw as throwError } from 'rxjs/observable/throw';
import { of } from 'rxjs/observable/of';
import { catchError } from 'rxjs/operators';
import { DataService } from './data.service';
import { BusinesLogicService } from './business-logic.service';
var HttpErrorFilter = (function () {
    function HttpErrorFilter(_data, _blogic) {
        this._data = _data;
        this._blogic = _blogic;
        this.tokenSubject = new BehaviorSubject(null);
    }
    HttpErrorFilter.prototype.intercept = function (request, next) {
        var _this = this;
        return next.handle(request).pipe(catchError(function (error) {
            if (error.status !== 404 && error.status !== 401 && error.status !== 403 && error.status !== 422 && error.status !== 500 && error.status !== 400) {
                return of(_this._data.redError = true);
            }
            else if ((error.status === 401 || error.status === 403)) {
                _this._blogic.logout().subscribe(function () {
                    localStorage.clear();
                    window.location.reload();
                });
            }
            return throwError(error);
        }));
    };
    return HttpErrorFilter;
}());
export { HttpErrorFilter };
